/* eslint-disable react/forbid-prop-types */
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';

import debounce from 'commons/utils/debounce';

const useStyles = makeStyles()((theme) => ({
  formControl: {
    margin: theme.spacing(1),
  },
}));

// COMPONENT
function AutocompleteField({
  label,
  placeholder,
  getSuggestionLabel,
  onChangeSearchTerm,
  onChange,
  touch,
  value,
  error,
  name,
  blurOnSelect,
  inputStyle,
}) {
  const { classes } = useStyles();
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceOnChange = useCallback(
    debounce((query) => {
      onChangeSearchTerm(query, setIsLoading).then((resp) => {
        setSuggestions(resp);
      });
    }, 400),
    [onChangeSearchTerm],
  );

  return (
    <Autocomplete
      fullWidth
      openOnFocus={false}
      noOptionsText={`Nenhum resultado.${searchTerm.trim().length === 0 ? ' Digite para buscar...' : ''}`}
      // open={open}
      onInputChange={(event, value) => {
        setSearchTerm(value);
        const currentInputValue = value;
        if (!currentInputValue || currentInputValue.trim().length === 0) {
          setSuggestions([]);
          return;
        }
        debounceOnChange(currentInputValue);
      }}
      value={value}
      onChange={(event, value) => {
        onChange(name, value);
      }}
      blurOnSelect={blurOnSelect}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      getOptionLabel={(option) => (option ? getSuggestionLabel(option) : '')}
      options={suggestions}
      loadingText="Carregando..."
      loading={isLoading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          InputLabelProps={{
            shrink: true,
          }}
          variant="standard"
          InputProps={{
            autoComplete: 'off',
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          error={touch && error != null}
          helperText={touch && error}
          className={classes.formControl}
          style={inputStyle}
        />
      )}
    />
  );
}

AutocompleteField.defaultProps = {
  placeholder: null,
};

AutocompleteField.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onChangeSearchTerm: PropTypes.func.isRequired,
  getSuggestionLabel: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  areItemsDifferentChecker: PropTypes.func,
};

AutocompleteField.defaultProps = {
  onChange: () => {},
  areItemsDifferentChecker: (prevItem, item) => {
    return (
      (prevItem == null && item != null) ||
      (prevItem != null && item == null) ||
      (prevItem != null && item != null && prevItem.id !== item.id)
    );
  },
};

export default AutocompleteField;
